import * as environment from '../../../config/environment';

import { BaseAPI } from "../../BaseAPI";


class MahalleListeAPI extends BaseAPI {


  constructor() {
    const baseUrl = environment.API_URL + "MahalleListe";
    super(baseUrl);
  }


  getMahalleListe(bolgeKodu?: number, mahalleKodu?: number) {

    return this.get("", { params: { bolgeKodu: bolgeKodu, mahalleKodu: mahalleKodu } });
  }
}
export default new MahalleListeAPI();
